module.exports = __webpack_public_path__ + "img/WhyUpgrade.8bfc6b1c.png";